import { render } from "./ToolbarDropdown.vue?vue&type=template&id=f0747532"
import script from "./ToolbarDropdown.vue?vue&type=script&lang=js"
export * from "./ToolbarDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/ToolbarDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0747532"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0747532', __exports__)) {
    console.log('reload')
    api.reload('f0747532', __exports__)
  }
  
  module.hot.accept("./ToolbarDropdown.vue?vue&type=template&id=f0747532", () => {
    console.log('re-render')
    api.rerender('f0747532', render)
  })

}


export default __exports__